var $eb1e0d6d87dadd36$exports = {};
$eb1e0d6d87dadd36$exports = {
    "endTime": `Sluttid`,
    "startTime": `Starttid`,
    "time": `Tid`
};


export {$eb1e0d6d87dadd36$exports as default};
//# sourceMappingURL=sv-SE.module.js.map
